module.exports = __webpack_public_path__ + "img/icon_map_jlzd.c522839c.png";